import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const EHIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="EH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="m0 0 8 6-8 6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        d="M10.844 4.181s-1.138.598-1.138 1.734c0 1.128 1.122 1.814 1.137 1.824-.526.147-2.273-.155-2.274-1.787 0-1.632 1.766-2.094 2.275-1.77Zm1.313 1.867.588.575-.777-.172-.15.793-.341-.857-.787-.256.64-.304-.228-.791.662.62.592-.22-.199.612Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
